<template>
  <div class="homecss">
    <div class="top-banner">
      <el-image
        class="carouselimgsize"
        style="width: 100%; opacity: 0"
        :src="img"
        :fit="fit"
      />
      <el-carousel class="carouselimg">
        <el-carousel-item>
          <el-image class="carouselimgsize" :src="img" :fit="fit" />
        </el-carousel-item>
        <el-carousel-item v-if="!isH5">
          <el-image
            class="carouselimgsize"
            :src="require('@/assets/topbanner1.jpg')"
            :fit="fit"
          />
        </el-carousel-item>
        <el-carousel-item v-if="!isH5">
          <el-image
            class="carouselimgsize"
            :src="require('@/assets/topbanner2.jpg')"
            :fit="fit"
          />
        </el-carousel-item>
        <el-carousel-item v-if="!isH5">
          <el-image
            class="carouselimgsize"
            :src="require('@/assets/topbanner3.jpg')"
            :fit="fit"
          />
        </el-carousel-item>
      </el-carousel>

      <el-image
        v-if="isH5"
        class="nexttips"
        style="width: 0.5rem"
        :src="require('@/assets/h5/nexttips.png')"
      />
    </div>

    <div class="Aboutus">
      <el-image
        style="width: 100%"
        v-if="!isH5"
        :src="require('@/assets/indexcontbg.png')"
        :fit="fit"
      />
      <el-image
        style="width: 100%"
        v-else
        :src="require('@/assets/h5/indexcontbg.png')"
        :fit="fit"
      />
      <div class="w1200">
        <div class="indexleft">
          <p>
            {{ $t(`Aboutus.about1`) }}
          </p>
          <p>
            <!-- {{ $t(`Aboutus.about2`) }} -->
          </p>
          <!-- <p>
            {{ $t(`Aboutus.about3`) }}
          </p> -->
        </div>
        <div class="indexright">
          <el-image
            class="imgw145"
            :src="autoimgyn == 'en' ? autoimgen : autoimg"
          />
        </div>
      </div>
      <el-image
        v-if="isH5"
        class="nexttips"
        style="width: 0.5rem"
        :src="require('@/assets/h5/nexttips.png')"
      />
    </div>
    <div class="WeGame">
      <el-image
        v-if="!isH5"
        style="width: 100%"
        :src="require('@/assets/indexcontbg2.png')"
        :fit="fit"
      />
      <el-image
        v-else
        style="width: 100%"
        :src="require('@/assets/h5/indexcontbg2.png')"
        :fit="fit"
      />
      <div class="po">
        <el-image
          class="potitle"
          :src="autoimgyn == 'en' ? gameimgen : gameimg"
        />

        <el-carousel
          ref="carouselRef"
          class="carouselimg2"
          :autoplay="false"
          trigger="click"
          @change="carouselChange"
        >
          <el-carousel-item v-for="x in gameBanner.length" :key="x">
            <div class="game-detail">
              <div class="game-five-banner">
                <el-carousel class="carouselimg3">
                  <el-carousel-item
                    v-for="item in gameBanner[x - 1]"
                    :key="item"
                  >
                    <div class="c2-img">
                      <el-image
                        :src="require(`@/assets/banner/game${x}${item}.jpg`)"
                        :fit="fit"
                      />
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="game-content">
                <div class="game-name">
                  <el-image
                    class="navimg"
                    v-if="!isH5"
                    :src="require(`@/assets/nav.png`)"
                  />
                  <span class="name-span">{{
                    $t(`Game.list[${x - 1}].name`)
                  }}</span>
                </div>
                <div class="game-description">
                  {{ $t(`Game.list[${x - 1}].introduction`) }}
                </div>
                <div class="game-link">
                  <a :href="$t(`Game.list[${x - 1}].facebook`)" target="_blank"
                    >Facebook</a
                  >
                  <span style="margin: 0 10px">|</span>
                  <a :href="$t(`Game.list[${x - 1}].discord`)" target="_blank"
                    >Discord</a
                  >
                  <span
                    style="margin: 0 10px"
                    v-if="$t(`Game.list[${x - 1}].ios`)"
                    >|</span
                  >
                  <a
                    v-if="$t(`Game.list[${x - 1}].ios`)"
                    :href="$t(`Game.list[${x - 1}].ios`)"
                    target="_blank"
                    >iOS</a
                  >
                  <span
                    style="margin: 0 10px"
                    v-if="$t(`Game.list[${x - 1}].android`)"
                    >|</span
                  >
                  <a
                    v-if="$t(`Game.list[${x - 1}].android`)"
                    :href="$t(`Game.list[${x - 1}].android`)"
                    target="_blank"
                    >Android</a
                  >
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>

        <div class="banner-right">
          <el-image
            class="rightimg"
            :src="
              carouselIndex === 0
                ? require('@/assets/leftn.png')
                : require('@/assets/lefty.png')
            "
            @click="handlePrev"
          />
          <el-image
            class="rightimg"
            :src="
              carouselIndex === carouselTotal - 1
                ? require('@/assets/rightn.png')
                : require('@/assets/righty.png')
            "
            @click="handleNext"
          />
        </div>
      </div>
      <el-image
        v-if="isH5"
        class="nexttips"
        style="width: 0.5rem"
        :src="require('@/assets/h5/nexttips.png')"
      />
    </div>
    <div class="Contactus-Index">
      <el-image
        v-if="!isH5"
        style="width: 100%"
        :src="require('@/assets/indexcontbg3.png')"
        :fit="fit"
      />
      <el-image
        v-else
        style="width: 100%"
        :src="require('@/assets/h5/indexcontbg3.png')"
        :fit="fit"
      />
      <div class="w1400">
        <div class="Contactus-Index_left pr">
          <div class="Contactus-Index_left_img">
            <el-image
              v-if="!isH5"
              style="width: 100%"
              :src="require('@/assets/dt.png')"
              :fit="fit"
            />
            <el-image
              v-else
              style="width: 100%"
              :src="require('@/assets/h5/dt.png')"
              :fit="fit"
            />
          </div>
          <div class="pa Contactus-Index_left_cont">
            <div>
              <el-image :src="require('@/assets/nav.png')" />
              <span class="con-font1">{{ $t(`contactus.title`) }}</span>
            </div>
            <div class="con-font2">
              <el-image :src="require('@/assets/nav2.png')" />
              <span style="margin-left: 10px">{{
                $t(`contactus.address`)
              }}</span>
            </div>
          </div>

          <div class="Contactus-Index_bottem">
            <ul>
              <li>
                <p>
                  <el-image
                    style="height: 20px; margin-right: 10px"
                    :src="require('@/assets/Emai.png')"
                  />
                  <b>Email</b>
                  <samp>xinshengcrm@gmail.com</samp>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="Contactus-Index_rigth">
          <el-image
            class="imgw"
            :src="autoimgyn == 'en' ? usindexen : usindex"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: `home`,
  setup() {
    const h5top = require('@/assets/h5/topimg.png')
    const pcTop = require('@/assets/topimg.jpg')
    const isH5 = ref(false)
    const img = computed(() => (isH5.value ? h5top : pcTop))
    const gameBanner = ref([6, 1])

    const mediaQuery = window.matchMedia('(max-width: 750px)')
    const onMediaChange = (e) => {
      isH5.value = e.matches
    }
    onMounted(() => {
      isH5.value = mediaQuery.matches
      mediaQuery.addEventListener('change', onMediaChange)
    })
    onUnmounted(() => {
      mediaQuery.removeEventListener('change', onMediaChange)
    })
    const autoimg = require('@/assets/autoindex.png')
    const autoimgen = require('@/assets/en/autoindex.png')
    const gameimg = require('@/assets/gameindex.png')
    const gameimgen = require('@/assets/en/gameindex.png')
    const usindex = require('@/assets/usindex.png')
    const usindexen = require('@/assets/en/usindex.png')
    const autoimgyn = sessionStorage.getItem('lang')
    const li_img = ''
    const router = useRouter()

    const carouselRef = ref(null)
    const carouselIndex = ref(0)
    const carouselTotal = 2
    const carouselChange = (index) => {
      carouselIndex.value = index
    }

    const handlePrev = () => {
      if (carouselIndex.value > 0) {
        carouselRef.value.prev()
      }
    }
    const handleNext = () => {
      if (carouselIndex.value < carouselTotal - 1) {
        carouselRef.value.next()
      }
    }

    const goDetail = (type) => {
      if (type.length < 1) {
        return
      }
      router.push(`/Gameinside?id=${type}`)
    }
    return {
      gameBanner,
      img,
      isH5,
      li_img,
      autoimg,
      autoimgen,
      gameimg,
      gameimgen,
      usindex,
      usindexen,
      autoimgyn,
      goDetail,
      carouselRef,
      carouselIndex,
      carouselTotal,
      carouselChange,
      handlePrev,
      handleNext,
    }
  },
}
</script>

<style scoped>
.c2-img {
  padding: 12px;
  background: orange;
  border-radius: 5px;
}
</style>
